import { ModalProp } from "../../components/modal/Modal";
import { ConfirmModal } from "./ConfirmModal";

export type RegistConfirmationModalProps = {
  handle: () => Promise<void>;
  title?: any;
  body?: any;
}

export const RegistConfirmationModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handle,
  title,
  body,
}: ModalProp & RegistConfirmationModalProps) => {
  return (
    <>
      <ConfirmModal 
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
        handle={handle}
        children
        contentType={"regist"}
        title={title}
        body={body}
      />
    </>
  );
}
